import { render, staticRenderFns } from "./RequestsNavbar.vue?vue&type=template&id=8558f842&scoped=true&"
import script from "./RequestsNavbar.vue?vue&type=script&lang=js&"
export * from "./RequestsNavbar.vue?vue&type=script&lang=js&"
import style0 from "./RequestsNavbar.vue?vue&type=style&index=0&id=8558f842&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8558f842",
  null
  
)

export default component.exports